import { createContext, useContext } from 'react';

const TableContext = createContext();

function Table({ children, cols, customTable, print }) {
  return (
    <TableContext.Provider value={{ cols }}>
      <div className={customTable === false ? 'mx-1' : 'c-table'}>
        <table
          id='table'
          className='table is-fullwidth is-bordered is-hoverable is-narrow'
          style={print ? { borderCollapse: 'collapse !important' } : {}}
          border='1'
        >
          {children}
        </table>
      </div>
    </TableContext.Provider>
  );
}

function Header({ children }) {
  return (
    <thead className='has-text-centered'>
      <tr>{children}</tr>
    </thead>
  );
}

function Row({ children }) {
  let checkCildren = children;
  if (typeof children !== 'string') checkCildren.toString();
  return <tr>{children}</tr>;
}

function Body({ data, render }) {
  const { cols } = useContext(TableContext);

  if (!data?.length)
    return (
      <tbody>
        <tr>
          <td className='middle pl-3' colSpan={cols} style={{ height: 48 }}>
            Tidak ada data
          </td>
        </tr>
      </tbody>
    );
  return <tbody>{data.map(render)}</tbody>;
}

Table.Header = Header;
Table.Row = Row;
Table.Body = Body;

export default Table;
